import { createRpcClientV2 } from 'rpc-client-utils';
import httpNoPortal from 'hub-http/clients/noPortalApiClient';
import http from 'hub-http/clients/apiClient';
export const rpcNoPortalClient = createRpcClientV2({
  hubHttpClient: httpNoPortal
});
export const rpcClient = createRpcClientV2({
  hubHttpClient: http
});